import { LoadingOutlined } from '@ant-design/icons'
import { Menu, MenuProps, Popover, Spin, Typography } from 'antd'
import { IndicationSet } from 'features/indicationTriage'
import React, { FC, useContext, useMemo } from 'react'
import styled from 'styled-components'
import { GeckoOrganization } from 'types'

import { CollapseContext } from './HoverCollapseSider'
import { IndicationClassificationCountDisplay } from './IndicationCountDisplay'

export interface OrganizationSelectSidebarProps {
  organizations: ReadonlyArray<GeckoOrganization>
  indicationSets: ReadonlyArray<IndicationSet>
  isLoading: boolean
  selectedOrgId: string | null
  onSelect: (orgId: string | null) => void
}

const SidebarContainer = styled.div``

const { Title } = Typography

type MenuItem = Required<MenuProps>['items'][number]

function createMenuItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[]
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
  } as MenuItem
}

export const OrganizationSelectSidebar: FC<OrganizationSelectSidebarProps> = ({
  organizations,
  indicationSets,
  isLoading,
  selectedOrgId,
  onSelect,
}) => {
  const { isCollapsed } = useContext(CollapseContext)
  const menuItems = useMemo(
    () =>
      organizations.map((org) => {
        const iSets = indicationSets.filter(
          (iSet) => iSet.tags.organization === org.id
        )
        const label = !isCollapsed ? (
          <Popover
            content={
              <IndicationClassificationCountDisplay indicationSets={iSets} />
            }>
            {org.data.name}
          </Popover>
        ) : (
          org.data.name
        )
        return createMenuItem(label, org.id)
      }),
    [indicationSets, isCollapsed, organizations]
  )
  return (
    <>
      <Title level={4}>Orgs</Title>
      <SidebarContainer>
        <Spin spinning={isLoading} indicator={<LoadingOutlined />}>
          {selectedOrgId ? (
            <Menu
              mode='inline'
              theme='dark'
              items={menuItems}
              onSelect={({ key }) => onSelect?.(key as string)}
              selectedKeys={[selectedOrgId]}
              selectable={!!onSelect}
            />
          ) : undefined}
        </Spin>
      </SidebarContainer>
    </>
  )
}
